/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Dashboard_Check_In_MembersInputs */

const en_admin_dashboard_check_in_members = /** @type {(inputs: Admin_Dashboard_Check_In_MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check in members`)
};

const de_admin_dashboard_check_in_members = /** @type {(inputs: Admin_Dashboard_Check_In_MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mitglieder einchecken`)
};

const es_admin_dashboard_check_in_members = /** @type {(inputs: Admin_Dashboard_Check_In_MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registrar miembros`)
};

const fr_admin_dashboard_check_in_members = /** @type {(inputs: Admin_Dashboard_Check_In_MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistrer les membres`)
};

const nl_admin_dashboard_check_in_members = /** @type {(inputs: Admin_Dashboard_Check_In_MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leden inchecken`)
};

const it_admin_dashboard_check_in_members = /** @type {(inputs: Admin_Dashboard_Check_In_MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registra membri`)
};

const pt_br2_admin_dashboard_check_in_members = /** @type {(inputs: Admin_Dashboard_Check_In_MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fazer check-in de membros`)
};

const pl_admin_dashboard_check_in_members = /** @type {(inputs: Admin_Dashboard_Check_In_MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zamelduj członków`)
};

const hu_admin_dashboard_check_in_members = /** @type {(inputs: Admin_Dashboard_Check_In_MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tagok bejelentkeztetése`)
};

const ro_admin_dashboard_check_in_members = /** @type {(inputs: Admin_Dashboard_Check_In_MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inregistrati membrii`)
};

/**
* | output |
* | --- |
* | "Check in members" |
*
* @param {Admin_Dashboard_Check_In_MembersInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_dashboard_check_in_members = /** @type {((inputs?: Admin_Dashboard_Check_In_MembersInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Dashboard_Check_In_MembersInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_dashboard_check_in_members(inputs)
	if (locale === "de") return de_admin_dashboard_check_in_members(inputs)
	if (locale === "es") return es_admin_dashboard_check_in_members(inputs)
	if (locale === "fr") return fr_admin_dashboard_check_in_members(inputs)
	if (locale === "nl") return nl_admin_dashboard_check_in_members(inputs)
	if (locale === "it") return it_admin_dashboard_check_in_members(inputs)
	if (locale === "pt-BR") return pt_br2_admin_dashboard_check_in_members(inputs)
	if (locale === "pl") return pl_admin_dashboard_check_in_members(inputs)
	if (locale === "hu") return hu_admin_dashboard_check_in_members(inputs)
	return ro_admin_dashboard_check_in_members(inputs)
});
export { admin_dashboard_check_in_members as "admin.dashboard.check_in_members" }